// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckoutFormIndirizzoBlock_root__lkDBl","title":"CheckoutFormIndirizzoBlock_title__0hZU8","rotation":"CheckoutFormIndirizzoBlock_rotation__ncYE1"};